import React, { Fragment } from 'react'
import List from '../../../../components/Project/Resources/Departments/List'
import DepartmentModal from '../../../../components/Project/Resources/Departments/DepartmentsModal'

function Departments(props) {
  return (
    <Fragment>
      <DepartmentModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

Departments.propTypes = {}
Departments.defaultProps = {}

export default Departments
